import { Box, Container, SimpleGrid, VStack, Heading, Text, Link as ChakraLink } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

const productLinks = [
  { label: 'Features', to: '/#features' },
  { label: 'Pricing', to: '/#pricing' },
  { label: 'Compare', to: '/#comparison' },
];

const resourceLinks = [
  { label: 'Documentation', to: '/docs' },
  { label: 'Installation Guide', to: '/docs/installation' },
  { label: 'API Reference', to: '/docs/api' },
];

const companyLinks = [
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
  { label: 'Privacy Policy', to: '/privacy' },
];

const FooterColumn = ({ title, links }) => (
  <Box>
    <Heading size="sm" color="white" mb={4}>{title}</Heading>
    <VStack align="start" spacing={2}>
      {links.map((link) => (
        <ChakraLink key={link.label} as={RouterLink} to={link.to} _hover={{ color: 'white' }}>{link.label}</ChakraLink>
      ))}
    </VStack>
  </Box>
);

export const MarketingFooter = () => (
  <Box bg="gray.900" color="gray.400" py={16} px={8}>
    <Container maxW="1200px">
      <SimpleGrid columns={{ base: 1, md: 4 }} spacing={8} mb={12}>
        <Box>
          <Text fontFamily="logo" fontWeight="800" fontSize="xl" bgGradient="linear(to-r, brand.500, accent.500)" bgClip="text" mb={4}>StatFalcon</Text>
          <Text fontSize="sm" lineHeight="1.7">Web analytics and ad serving in one platform — in our cloud or self-hosted. Track visitors, serve ads, and maximize revenue with complete data ownership.</Text>
        </Box>
        <FooterColumn title="Product" links={productLinks} />
        <FooterColumn title="Resources" links={resourceLinks} />
        <FooterColumn title="Company" links={companyLinks} />
      </SimpleGrid>
      <Box borderTop="1px solid" borderColor="gray.800" pt={8} textAlign="center">
        <Text fontSize="sm">&copy; 2026 StatFalcon. All rights reserved.</Text>
      </Box>
    </Container>
  </Box>
);

export default MarketingFooter;
